import React, { Component } from 'react'
// connect方法的作用：将额外的props传递给组件，并返回新的组件，组件在该过程中不会受到影响
import { connect } from 'react-redux'
// 引入action
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { navshow } from '../../tool/navtool';
import  './css.css';

class SearchModal extends Component {
    constructor(props) {
        super(props)
        this.state={
            show:false
        }
    }

    componentDidMount() {
        this.props.onRef(this)
    }
    changeModal = (e)=>{
        this.setState({
            show:e
        })
    }
   
    find=(event)=>{
        if(event.which ==13){
            this.props.history.push({
                pathname: '#/Search?search='+this.inputSearch.value,
              });
              this.props.history.go() 
        }
    }

    render() {
        const {show}=this.state
       return <>
      { show
        ?
       <div ref={e=>this.SearchModal=e} className="js-search search-form search-form--modal is-visible" >{/**method="get" action={window.location.origin} role="search" */}
                <div className="search-form__inner">
                    <div>
                        <p className="micro mb-">想要找点什么呢？</p>
                        <i className="iconfont icon-search"></i>
                        <input ref={e=>this.inputSearch=e} className="text-input" type="text" name="search" placeholder="" required="" onKeyPress={this.find}/>
                    </div>
                </div>

                <div className="search_close" onClick={()=>this.changeModal(false)}></div>
            </div>
        :
        null
      }
        </>
    }
}



const styles = {
                    header: {

                },
    inline_block: {
                    display: "inline-block"
    },
    name: {

                },
    aa: {
                    height: "100%",
        cursor: "pointer",
        zIndex: 9,
        color: "inherit",
        textDecoration: "none",
        fontWeight: "500",
        lineHeight: "80px",
    },
    a: {
                    cursor: "pointer",
        margin: "0 2.5rem",
        color: "inherit",
        textDecoration: "none",
        fontWeight: "500",
        lineHeight: "80px",
    }
}




export default connect()(SearchModal)